import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  show() {
    const url = apiRoutes.loanOfficerSubscriptionInfoPath();

    return FetchHelpers.get(url);
  },
  update(params) {
    const url = apiRoutes.loanOfficerSubscriptionInfoPath();

    return FetchHelpers.post(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/SubscriptionInfoRepository.js